type ActorList = Array<{ id?: string | null; email?: string | null }>

export type DeriveAcknowledgementReceiversInput = {
  subscriptions?: { users?: ActorList; freighties?: ActorList } | null
  bookingRecipients?: Array<string | null | undefined> | null
  // Users who opted out of the ShipmentCreated email; dropped from the result.
  disabledUserIds?: ReadonlySet<string>
}

// Excludes opted-out users and non-email entries (contacts without an email arrive as '-'), deduped.
export const deriveAcknowledgementReceivers = ({
  subscriptions,
  bookingRecipients,
  disabledUserIds,
}: DeriveAcknowledgementReceiversInput): string[] => {
  const subscriptionEmails = [...(subscriptions?.users ?? []), ...(subscriptions?.freighties ?? [])]
    .filter((actor) => !(actor.id && disabledUserIds?.has(actor.id)))
    .map((actor) => actor.email)

  const seen = new Set<string>()
  const receivers: string[] = []

  for (const raw of [...subscriptionEmails, ...(bookingRecipients ?? [])]) {
    const email = raw?.trim()
    if (!email || !email.includes('@')) {
      continue
    }
    const key = email.toLowerCase()
    if (seen.has(key)) {
      continue
    }
    seen.add(key)
    receivers.push(email)
  }

  return receivers
}
